export const PLAYER_TYPE = {
    SIMPLE: 0,
    FULL: 1
}